import { Box, SpaceBetween } from "@cloudscape-design/components-themed";
import { LABELS } from "./constants";

const TableEmptyState = () => (
  <Box margin={{ vertical: "xs" }} textAlign="center" color="inherit">
    <SpaceBetween size="xxs">
      <Box variant="p" color="inherit">
        {LABELS.EMPTY_DATA}
      </Box>
    </SpaceBetween>
  </Box>
);

export default TableEmptyState;
